export default "__VITE_ASSET__Dp_wYUy7__"